(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('water-network', {
            parent: 'entity',
            url: '/water-network?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.waterNetwork.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/water-network/water-networks.html',
                    controller: 'WaterNetworkController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('waterNetwork');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('water-network-detail', {
            parent: 'entity',
            url: '/water-network/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.waterNetwork.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/water-network/water-network-detail.html',
                    controller: 'WaterNetworkDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('waterNetwork');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'WaterNetwork', function($stateParams, WaterNetwork) {
                    return WaterNetwork.get({id : $stateParams.id});
                }]
            }
        })
        .state('water-network.new', {
            parent: 'water-network',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/water-network/water-network-dialog.html',
                    controller: 'WaterNetworkDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('water-network', null, { reload: true });
                }, function() {
                    $state.go('water-network');
                });
            }]
        })
        .state('water-network.edit', {
            parent: 'water-network',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/water-network/water-network-dialog.html',
                    controller: 'WaterNetworkDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['WaterNetwork', function(WaterNetwork) {
                            return WaterNetwork.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('water-network', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('water-network.delete', {
            parent: 'water-network',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/water-network/water-network-delete-dialog.html',
                    controller: 'WaterNetworkDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['WaterNetwork', function(WaterNetwork) {
                            return WaterNetwork.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('water-network', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
